import { Desktop, Lightning, Star } from "@phosphor-icons/react";

export const fmtDate = (iso) => {
  if (!iso) return "the end of your billing period";
  try { return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" }); }
  catch { return "the end of your billing period"; }
};

export const PLAN_STYLE = {
  personal: { accent: "border-white/10", icon: Desktop, glow: "" },
  solo: { accent: "border-emerald-500/40", icon: Lightning, glow: "shadow-lg shadow-emerald-500/10" },
  group: { accent: "border-cyan-500/40", icon: Lightning, glow: "shadow-lg shadow-cyan-500/10" },
  smallbiz: { accent: "border-amber-500/40", icon: Star, glow: "shadow-lg shadow-amber-500/10" },
  // Legacy (grandfathered) styles.
  starter: { accent: "border-emerald-500/40", icon: Lightning, glow: "shadow-lg shadow-emerald-500/10" },
  pro: { accent: "border-cyan-500/40", icon: Lightning, glow: "shadow-lg shadow-cyan-500/10" },
  business: { accent: "border-blue-500/40", icon: Lightning, glow: "shadow-lg shadow-blue-500/10" },
  enterprise: { accent: "border-amber-500/40", icon: Star, glow: "shadow-lg shadow-amber-500/10" },
};
